import searchGlass from "@/icons/search2.svg";
import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";

function  setURLParams(input: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete("q");
  urlParams.set("q",input);
  history.pushState(
    null,
    "",
    `${window.location.pathname}?q=${encodeURIComponent(input)}`
  );
}
const Pill = ({ searchTerm,handlePrompt = () => {} }: { searchTerm: string;handlePrompt?: (query: string) => void; }) => {
  const handlePillClick = () => {
    dispatchCustomEvent({
      dataObject: "error-block",
      dataType: "button",
      dataReason: "inspo-click",
    });
    setURLParams(searchTerm);
    handlePrompt(searchTerm);
  };

  return (
    <button
      className="syfclickevent max-w-full sm:max-w-[334px] text-[14px] text-charcoal py-[8px] px-[14px] rounded-[27px] border border-[#D9D9D9] flex  justify-between"
      onClick={handlePillClick}
    >
      <span>{searchTerm}</span>
      <img
        src={searchGlass}
        alt=""
        className="ml-[8px] w-[20px] h-[21px] mb-[2px]"
      />
    </button>
  );
};

export default Pill;
